import React, { useEffect, useState } from 'react';
import { FieldRenderProps } from 'react-final-form';

import { FormFieldWrapper, BankCardInput, Label } from './styles';

// interface PhoneFormFieldProps extends FieldRenderProps<string> {
//   label: string;
// }

const BankCardField = ({ input, meta, label, ...rest }) => {
  return (
    <FormFieldWrapper>
      {label && <Label>{label}</Label>}
      <BankCardInput
        {...input}
        {...rest}
        $error={meta.touched && meta.error}
        $valid={meta.touched && !meta.error}
      />
      {meta.error &&
        meta.touched &&
        meta.error.map((error) => (
          <div key={error} className="error">
            {error}
          </div>
        ))}
    </FormFieldWrapper>
  );
};

export { BankCardField };
